module.exports = __webpack_public_path__ + "img/9D4343_E38989_D37474_CE6C6C-256px.563e3bcd.png";